<template lang="pug">
  .wrap
    .main
      h2 CSV ファイル一覧
      .job-list
        .job-list-body
          table.row-list
            tr.row.row-title
              th.col.check
              th.col
                span ファイル
              th.col
                span サイズ（kbyte）
              th.col
                span 作成日
            tr.row(v-for="(csvFile,i) in index")
              td.col.check {{ i + 1 }}
              td.col.csv_file
                a(:href="csvFile.preSignedURL") {{ csvFile.fileName }}
              td.col {{ csvFile.fileSize }}
              td.col {{ csvFile.updatedAt }}

    Footer
</template>

<script>
  import { mapState } from 'vuex'
  import Footer from '../parts/Footer'

  export default {
    components: {
      Footer,
    },
    async asyncData ({ store, route: { query } }) {
      await store.dispatch('csvFile/fetchIndex', query)
    },
    computed: {
      ...mapState({
        user: state => state.user.detail,
        meta: state => state.route.meta,
        pagination: state => state.csvFile.pagination,
        index: state => state.csvFile.index,
      }),
      page () {
        return this.$route.query.page
      },
      perPage () {
        return this.$route.query.perPage
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/s3/CsvFile.vue